import { GESTION_OPERATIVA_SET_HAS_PHYSICAL_DOCUMENTS } from './constants'
// TODO: array con valores validos de tags. Chequear con ese array, rebotar
// cuando se trate de setear un tag no válido

export function setHasPhysicalDocuments(tag, value = false) {
  const tagValido = true
  if (!tagValido) {
    return {
      type: 'GESTION_OPERATIVA_FILE_TAG_NO_VALIDO',
    }
  }
  return {
    type: GESTION_OPERATIVA_SET_HAS_PHYSICAL_DOCUMENTS,
    data: {
      tag,
      value,
    },
  }
}

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_SET_HAS_PHYSICAL_DOCUMENTS) {
      return {
        ...state,
        documents: {
          ...state.documents,
          [action.data.tag]: {
            ...state.documents[action.data.tag],
            hasPhysicalDocuments: action.data.value,
          },
        },
      }
  }
  else{
      return state
  }
}
